<div class="gl-page">
  <!-- Back link -->
  <yds-button-back text="Ga terug 'Overzicht grootboek'" (back)="goBack()" />

  <!-- Title + page actions -->
  <div class="gl-page__header">
    <h1 class="gl-page__title">Grootboek</h1>
    <div class="gl-page__header-actions">
      @if (!isAddMode()) {
        <yds-button (click)="goToGeneralLedgerAccount()">Grootboekrekening</yds-button>
        <yds-button (click)="goToGeneralLedgerGroup()">Grootboekrekeningengroep</yds-button>
        <yds-button variant="destructive" (click)="onDelete()">Verwijderen</yds-button>
      }
    </div>
  </div>

  @if (isLoading()) {
    <div class="gl-detail-loading">
      <yds-spinner [label]="'Grootboek laden...'" />
    </div>
  } @else if (notFound()) {
    <p class="gle-empty">Er zijn geen details voor grootboek gevonden.</p>
  } @else {
    <!-- Details card -->
    <yds-card-editable
      title="Details"
      [(editing)]="detailsEditing"
      [nextDisabled]="isSaving() || form.invalid"
      [nextLabel]="'Opslaan'"
      (cancel)="onDetailsCancel()"
      (next)="onDetailsNext()"
    >
      @if (detailsEditing()) {
        <form class="gl-form" [formGroup]="form">
          <p class="gl-form__required-hint">
            Velden gemarkeerd met een sterretje
            (<span class="gl-form__required-hint-asterisk" aria-hidden="true">*</span>) zijn verplicht.
          </p>

          <div class="gl-field">
            <label class="gl-field__label">
             <span class="gl-form__required-hint-asterisk" aria-hidden="true">*</span> Naam 
            </label>
            <div class="gl-field__control">
              <yds-text-field
                formControlName="generalLedgerName"
                [required]="true"
                [hasError]="isInvalid(form.get('generalLedgerName'))"
                [errorMsg]="'Naam is verplicht.'"
                [placeholder]="'Voer een naam in'"
              />
            </div>
          </div>

          <div class="gl-field">
            <label class="gl-field__label">
             <span class="gl-form__required-hint-asterisk" aria-hidden="true">*</span> Begindatum 
            </label>
            <div class="gl-field__control">
              <yds-date-picker
                formControlName="startDate"
                [required]="true"
                [locale]="translate.getCurrentLang()"
                [placeholder]="'dd-mm-jjjj'"
                [allowTodayAction]="false"
                [dateFilter]="firstDayOfMonthFilter"
                [errorMessage]="isInvalid(form.get('startDate')) ? 'Begindatum is verplicht.' : ''"
              />
            </div>
          </div>

          <div class="gl-field">
            <label class="gl-field__label">Einddatum</label>
            <div class="gl-field__control">
              <yds-date-picker
                formControlName="endDate"
                [locale]="translate.getCurrentLang()"
                [placeholderKey]="null"
                [placeholder]="''"
                [allowTodayAction]="false"
                [dateFilter]="lastDayOfMonthFilter"
                [errorMessage]="endDateError()"
              />
            </div>
          </div>

          <div class="gl-field">
            <label class="gl-field__label">Memo</label>
            <div class="gl-field__control">
              <yds-text-area
                formControlName="memoValue"
                [placeholder]="'Voer een memo in'"
                [maxLength]="500"
                [showCounter]="true"
              />
            </div>
          </div>
        </form>
      } @else {
        <div class="gl-detail">
          <div class="gl-detail__row">
            <span class="gl-detail__label">Naam</span>
            <span class="gl-detail__value">{{ generalLedgerName() }}</span>
          </div>
          <div class="gl-detail__row">
            <span class="gl-detail__label">Begindatum</span>
            <span class="gl-detail__value">{{ startDateDisplay() }}</span>
          </div>
          <div class="gl-detail__row">
            <span class="gl-detail__label">Einddatum</span>
            <span class="gl-detail__value">{{ endDateDisplay() }}</span>
          </div>
          <div class="gl-detail__row">
            <span class="gl-detail__label">Memo</span>
            <span class="gl-detail__value gl-detail__value--memo">{{ memoDisplay() }}</span>
          </div>
        </div>
      }
    </yds-card-editable>
  }
</div>
